/*
 * Project: Dynamedics Portal Web
 * Created Date: Thursday February 9th 2023
 * Author: KasunSKarunasekara
 * -----
 * Last Modified: Thursday February 9th 2023 6:08:25 pm
 * Modified By: KasunSKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import faker from 'faker';
//utils
import mock from '../utils/mock';
import fakeRequest from '../utils/fakeRequest';
import { reject } from 'lodash';
import { checkUndefinedOrNull } from 'src/utils/functions';
// ----------------------------------------------------------------------

let ATTACHED_SUPPLIERS = [
  {
    id: 1,
    name: 'Cocacola',
    email: 'info@cocacola.com',
    isin: '2376B',
    sector: 'Beverages',
    region: 'UK',
    addedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 2,
    name: 'Ferrari',
    email: 'contact@ferrari.com',
    isin: '256676A',
    sector: 'Transport',
    region: 'Italy',
    addedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 5,
    name: 'mcLaren',
    email: 'supply@mcLaren.com',
    isin: '655445',
    sector: 'Transport',
    region: 'Germany',
    addedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 6,
    name: 'Dell',
    email: 'support@dell.com',
    isin: '656534',
    sector: 'Technology',
    region: 'UK',
    addedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 7,
    name: 'Dilmah',
    email: 'suppliers@dilmah.com',
    isin: '4435',
    sector: 'Beverages',
    region: 'Sri Lanka',
    addedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  }
];

let SUPPLIERS = [
  {
    id: 1,
    name: 'Cocacola',
    email: 'info@cocacola.com',
    isin: '2376B',
    sector: 'Beverages',
    region: 'UK',
    website: 'https://www.coca-colacompany.com',
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 2,
    name: 'Ferrari',
    email: 'contact@ferrari.com',
    isin: '256676A',
    sector: 'Transport',
    region: 'Italy',
    website: 'https://www.ferrari.com/en-EN',
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 3,
    name: 'DHL',
    email: 'support@dhl.com',
    isin: '5454A',
    sector: 'Transport',
    region: 'USA',
    website: 'https://www.dhl.com',
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: false,
    isActive: true
  },
  {
    id: 4,
    name: 'Hineken',
    email: 'suppliers@hineken.com',
    isin: '8886f',
    sector: 'Beverages',
    region: 'Germany',
    website: 'https://www.heinekenlanka.com',
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: false,
    isActive: true
  },
  {
    id: 5,
    name: 'mcLaren',
    email: 'supply@mcLaren.com',
    isin: '655445',
    sector: 'Transport',
    region: 'Germany',
    website: 'https://www.mclaren.com',
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 6,
    name: 'Dell',
    email: 'support@dell.com',
    isin: '656534',
    sector: 'Technology',
    region: 'UK',
    website: 'https://www.dell.com',
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 7,
    name: 'Dilmah',
    email: 'suppliers@dilmah.com',
    isin: '4435',
    sector: 'Beverages',
    region: 'Sri Lanka',
    website: 'https://www.dilmahtea.com',
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  }
];

let INVITED_SUPPLIERS = [
  {
    id: 1,
    name: 'Cocacola',
    email: 'info@cocacola.com',
    isin: '2376B',
    sector: 'Beverages',
    region: 'UK',
    website: 'https://www.coca-colacompany.com',
    invitedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 2,
    name: 'Ferrari',
    email: 'contact@ferrari.com',
    isin: '256676A',
    sector: 'Transport',
    region: 'Italy',
    website: 'https://www.ferrari.com/en-EN',
    invitedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 3,
    name: 'DHL',
    email: 'support@dhl.com',
    isin: '5454A',
    sector: 'Transport',
    region: 'USA',
    website: 'https://www.dhl.com',
    invitedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: false,
    isActive: true
  },
  {
    id: 4,
    name: 'Hineken',
    email: 'suppliers@hineken.com',
    isin: '8886f',
    sector: 'Beverages',
    region: 'Germany',
    website: 'https://www.heinekenlanka.com',
    invitedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: false,
    isActive: true
  },
  {
    id: 5,
    name: 'mcLaren',
    email: 'supply@mcLaren.com',
    isin: '655445',
    sector: 'Transport',
    region: 'Germany',
    website: 'https://www.mclaren.com',
    invitedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 6,
    name: 'Dell',
    email: 'support@dell.com',
    isin: '656534',
    sector: 'Technology',
    region: 'UK',
    website: 'https://www.dell.com',
    invitedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 7,
    name: 'Dilmah',
    email: 'suppliers@dilmah.com',
    isin: '4435',
    sector: 'Beverages',
    region: 'Sri Lanka',
    website: 'https://www.dilmahtea.com',
    invitedOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  }
];

let SUPPLIER_APPROVALS = [
  {
    id: 1,
    name: 'Cocacola',
    email: 'info@cocacola.com',
    isin: '2376B',
    sector: 'Beverages',
    region: 'UK',
    website: 'https://www.coca-colacompany.com',
    status: 2,
    registeredOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 2,
    name: 'Ferrari',
    email: 'contact@ferrari.com',
    isin: '256676A',
    sector: 'Transport',
    region: 'Italy',
    website: 'https://www.ferrari.com/en-EN',
    status: 2,
    registeredOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 3,
    name: 'DHL',
    email: 'support@dhl.com',
    isin: '5454A',
    sector: 'Transport',
    region: 'USA',
    website: 'https://www.dhl.com',
    status: 2,
    registeredOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: false,
    isActive: true
  },
  {
    id: 4,
    name: 'Hineken',
    email: 'suppliers@hineken.com',
    isin: '8886f',
    sector: 'Beverages',
    region: 'Germany',
    website: 'https://www.heinekenlanka.com',
    status: 2,
    registeredOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: false,
    isActive: true
  },
  {
    id: 5,
    name: 'mcLaren',
    email: 'supply@mcLaren.com',
    isin: '655445',
    sector: 'Transport',
    region: 'Germany',
    website: 'https://www.mclaren.com',
    status: 5,
    registeredOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 6,
    name: 'Dell',
    email: 'support@dell.com',
    isin: '656534',
    sector: 'Technology',
    region: 'UK',
    website: 'https://www.dell.com',
    status: 5,
    registeredOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  },
  {
    id: 7,
    name: 'Dilmah',
    email: 'suppliers@dilmah.com',
    isin: '4435',
    sector: 'Beverages',
    region: 'Sri Lanka',
    website: 'https://www.dilmahtea.com',
    status: 5,
    registeredOn: faker.date.past(),
    createdOn: faker.date.past(),
    modifiedOn: '',
    isAttached: true,
    isActive: true
  }
];

const DATA_SUBMISSIONS = [
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T12:22:12.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T14:14:22.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T14:14:43.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T14:15:27.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T14:24:57.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T14:19:14.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T15:05:44.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-05-31T15:33:51.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'Formula 01',
    submittedOn: '2023-06-01T04:38:31.000Z',
    isExpired: true
  },
  {
    supplierName: 'BT ',
    event: 'Formula 01',
    submittedOn: '2023-06-03T10:55:35.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'Formula 01',
    submittedOn: '2023-06-03T19:43:58.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'Formula 01',
    submittedOn: '2023-06-03T19:44:42.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-06-03T19:47:00.000Z',
    isExpired: true
  },
  {
    supplierName: 'Lamborghini',
    event: 'MotoGP',
    submittedOn: '2023-06-03T19:47:23.000Z',
    isExpired: true
  }
];

let SUPPLIER_INVITATION_URL =
  'http://test.supplier.experienz.co.uk/registration?token=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';

let attachedSuppliers = {
  data: [...ATTACHED_SUPPLIERS]
};

let suppliers = {
  data: [...SUPPLIERS]
};

let invitedSuppliers = {
  data: [...INVITED_SUPPLIERS]
};

let supplierApprovals = {
  data: [...SUPPLIER_APPROVALS]
};

let dataSubmissions = {
  data: [...DATA_SUBMISSIONS]
};

let invitationUrl = {
  data: { registrationLink: SUPPLIER_INVITATION_URL }
};

// ----------------------------------------------------------------------

mock.onPost('api/supplier').reply(async (request) => {
  await fakeRequest(1000);
  try {
    const { supplierId } = JSON.parse(request.data);
    let supplier = {};
    if (!checkUndefinedOrNull(supplierId)) {
      supplier = suppliers.data.find((supplier) => (supplier.id = supplierId));
      supplier.isAttached = true;

      attachedSuppliers.data = [...attachedSuppliers.data, supplier];
    }
    return [
      200,
      {
        data: {
          NumberOfInvitationSent: 30,
          NumberOfExistingCustomerAttached: 20
        }
      }
    ];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock.onGet('api/supplier').reply(async (config) => {
  await fakeRequest(1000);
  try {
    return [200, { ...attachedSuppliers }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock.onGet('api/supplier/find').reply(async (config) => {
  await fakeRequest(1000);
  try {
    return [200, { ...suppliers }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock.onDelete(/^\/api\/supplier\/[^\/]+/).reply(async (request) => {
  await fakeRequest(1000);
  try {
    const supplierId = request.url.split('/').slice(-1)[0];
    attachedSuppliers.data = reject(attachedSuppliers.data, { id: supplierId });
    attachedSuppliers.data = attachedSuppliers.data.filter(
      (supplier) => supplier.id != supplierId
    );
    return [200, { supplierId }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock.onGet('api/supplier/manage/invited').reply(async (config) => {
  await fakeRequest(1000);
  try {
    return [200, { ...invitedSuppliers }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock.onGet('api/supplier/admin/invitation-url').reply(async (config) => {
  await fakeRequest(1000);
  try {
    return [200, { ...invitationUrl }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock
  .onGet('api/supplier/admin/invitation-url/approvals')
  .reply(async (config) => {
    await fakeRequest(1000);
    try {
      return [200, { ...supplierApprovals }];
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });

// ----------------------------------------------------------------------

mock
  .onPost('api/supplier/admin/invitation-url/approvals')
  .reply(async (request) => {
    await fakeRequest(1000);
    try {
      return [200, {}];
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });

// ----------------------------------------------------------------------

mock.onGet('api/supplier/admin/data-submissions').reply(async (config) => {
  await fakeRequest(1000);
  try {
    return [200, { ...dataSubmissions }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});
